import {Injectable} from '@angular/core';
import {JdValidator} from '@jd/validator';
import {AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn} from "@angular/forms";
import {isString} from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class ValidatorService {
  _regTime = null;

  private _getData(control: AbstractControl, controlName: string) {
    return control.parent ?
      Object.assign({}, control.parent.value, {[controlName]: control.value}) :
      {[controlName]: control.value};
  }

  universal_valid_async(controlName: string, rules: string): AsyncValidatorFn;
  universal_valid_async(controlName: string, rules: string, msg: { [key: string]: any }): AsyncValidatorFn;
  universal_valid_async(controlName: string, rules: string, msg: { [key: string]: any }, delay): AsyncValidatorFn;
  universal_valid_async(controlName: string, rules: string, msg?: { [key: string]: any }, delay = 1000): AsyncValidatorFn {
    return async (control: AbstractControl): Promise<{ [key: string]: any }> => {
      clearTimeout(this._regTime);
      const validate = new JdValidator(),
        data: any = this._getData(control, controlName);

      return await new Promise((resolve) => {
        this._regTime = setTimeout(() => {
          resolve(validate.make({[controlName]: rules}, data, msg).getNgMsg(controlName));
        }, delay);
      });
    };
  }
  universal_valid(controlName: string, rules: string | any[]): ValidatorFn;
  universal_valid(controlName: string, rules: string | any[], msg: { [key: string]: any }): ValidatorFn;
  universal_valid(controlName: string, rules: string | any[], msg: string): ValidatorFn;
  universal_valid(controlName: string, rules: string | any[], msg?: { [key: string]: any } | string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const validate = new JdValidator(),
        data: any = this._getData(control, controlName);

      if (isString(msg)) {
        msg = {[controlName]: msg};
      }
      return validate.make({[controlName]: rules}, data, msg).getNgMsg(controlName)
    }
  }

  constructor() {
  }
}
